/* ==========================================================
   Kit Builder JS — passo a passo estilo Insider
   ========================================================== */

(function () {
  'use strict';

  class KitBuilder {
    constructor(el) {
      this.el          = el;
      this.sectionId   = el.dataset.section;
      this.productId   = el.dataset.productId;
      this.dataEl      = document.getElementById('kit-product-data-' + this.sectionId);
      if (!this.dataEl) return;

      this.data        = JSON.parse(this.dataEl.textContent);

      /* Modo multi-produto: pool de produtos configurado no bloco.
         Cada produto vira uma bolinha de cor; tamanho = variantes do ativo. */
      this.products    = this.data.products || [];
      this.multi       = this.products.length > 0;

      /* Produto da pagina vem pre-selecionado quando esta no pool */
      this.currentProductIdx = 0;
      if (this.multi) {
        const pageIdx = this.products.findIndex(p => String(p.id) === String(this.productId));
        if (pageIdx >= 0) this.currentProductIdx = pageIdx;
      }

      if (this.multi) {
        this.variants  = this.products[this.currentProductIdx].variants;
        this.options   = this.products[this.currentProductIdx].options;
      } else {
        this.variants  = this.data.variants;
        this.options   = this.data.options;
      }
      this.kitSizes    = this.data.kit_sizes.map(s => parseInt(s.trim(), 10));
      this.kitLabels   = this.data.kit_labels.map(s => s.trim());
      this.kitPrices   = this.data.kit_prices.map(s => s.trim());

      this.currentKitSize  = this.kitSizes[0] || 1;
      this.currentStep     = 1;
      this.selections      = [];

      /* Modo "compre e ganhe": pecas alem de giftPaid sao brinde */
      this.giftMode = false;
      this.giftPaid = 0;

      /* Pecas obrigatorias do kit compre e ganhe: trava o produto do passo
         pago N no fixedProducts[N-1]; o cliente escolhe apenas o tamanho. */
      this.fixedProducts = this.data.gift_fixed || [];
      this._renderMode   = 'pool';

      this.boxEl       = el.querySelector('.kit-builder__box');
      this.variantsEl  = el.querySelector('.kit-builder__variants');
      /* HTML original das opcoes (modo single-produto, renderizado no Liquid) —
         usado para restaurar apos um passo com peca obrigatoria */
      this._staticVariantsHTML = this.variantsEl ? this.variantsEl.innerHTML : '';
      this.btnNext     = el.querySelector('.kit-builder__btn-next');
      this.btnBack     = el.querySelector('.kit-builder__btn-back');
      this.backWrap    = el.querySelector('.kit-builder__back-wrap');
      this.btnText     = el.querySelector('.kit-builder__btn-text');
      this.stepBadge   = el.querySelector('.kit-builder__step-badge');
      this.stepText    = el.querySelector('.kit-builder__step-text');

      /* Textos do passo configuraveis no bloco (grupo "Textos do passo") */
      this.badgeShow     = this.data.step_badge_show !== false;
      this.badgeTemplate = this.data.step_badge_text || 'PASSO {passo} DE {total}';
      this.textShow      = this.data.step_text_show !== false;
      this.stepTexts = {
        normal: this.data.step_text_default || 'Escolha as opções para este item',
        fixed:  this.data.step_text_fixed  || 'Peça do kit — escolha o tamanho',
        gift:   this.data.step_text_gift   || 'Escolha o seu brinde'
      };
      this.priceValue  = el.querySelector('.kit-builder__price-value');
      this.priceCurrent= el.querySelector('.kit-builder__price-current');
      this.priceCompare= el.querySelector('.kit-builder__price-compare');
      this.priceSubtitle = el.querySelector('.kit-builder__item-subtitle');
      this.itemTitle   = el.querySelector('.kit-builder__item-title');
      this.thumb       = el.querySelector('.kit-builder__item-thumb img');
      this.tierBtns    = el.querySelectorAll('.kit-builder__tier-btn');

      if (this.multi) { this._syncProductHeader(); this._renderMultiVariants(); }
      this._buildSwatchStyles();
      this._buildProgressBar();
      this._bindTierBtns();
      this._bindNext();
      this._bindBack();
      this._bindVariantInputs();
      if (this.multi) this._bindProductSwatches();
      this._selectFirstAvailable();
      this._updateUI();

      /* Abre a pagina ja com o tier "compre e ganhe" selecionado */
      if (this.data.gift_default) {
        const giftBtn = el.querySelector('.kit-builder__tier-btn--gift');
        if (giftBtn) giftBtn.click();
      }
    }

    /* ══════════════════════════════════════════════════════
       MODO MULTI-PRODUTO
       Linha de cores: 1 bolinha por produto do pool.
       Demais opcoes: variantes do produto ativo.
       ══════════════════════════════════════════════════════ */

    _esc(str) {
      return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;')
        .replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
    }

    /* Valores unicos da opcao `optIdx` entre as variantes do produto */
    _optionValues(product, optIdx) {
      const seen = [];
      product.variants.forEach(v => {
        const val = v.options[optIdx];
        if (val != null && seen.indexOf(val) === -1) seen.push(val);
      });
      return seen;
    }

    _renderMultiVariants() {
      const p = this.products[this.currentProductIdx];

      /* ── Linha de cores (produtos) ── */
      let html = '<div class="kit-builder__option" data-kit-color-row>' +
        '<div class="kit-builder__option-name">' +
        '<span>Cor:</span> ' +
        '<span class="kit-builder__option-selected" data-kit-color-selected>' + this._esc(p.color_hint) + '</span>' +
        '</div><div class="kit-builder__option-values">';

      /* Cada produto vira uma miniatura com a foto (fallback: bolinha de cor) */
      this.products.forEach((prod, i) => {
        const id = 'kit-' + this.sectionId + '-prod-' + i;
        const labelClass = prod.image ? 'kit-builder__label--product' : 'kit-builder__label--swatch';
        const labelInner = prod.image
          ? '<img src="' + this._esc(prod.image) + '" alt="' + this._esc(prod.color_hint) + '" loading="lazy" width="44" height="44">'
          : this._esc(prod.color_hint);
        html +=
          '<input type="radio" class="kit-builder__radio kit-builder__radio--product" ' +
          'id="' + id + '" name="kit-' + this.sectionId + '-product" value="' + i + '"' +
          (i === this.currentProductIdx ? ' checked' : '') + '>' +
          '<label for="' + id + '" class="kit-builder__label ' + labelClass + ' tooltip-toggle" ' +
          'data-swatch="' + this._esc(prod.color_hint) + '" ' +
          'data-tooltip-text="' + this._esc(prod.color_hint) + '" data-tooltip-position="top">' +
          labelInner + '</label>';
      });
      html += '</div></div>';

      html += this._renderOptionRowsHTML(p);

      this.variantsEl.innerHTML = html;
    }

    /* ── Opcoes reais de um produto (ex: Tamanho) ──
       Opcoes com 1 valor so ficam ocultas (auto-selecionadas). */
    _renderOptionRowsHTML(p) {
      let html = '';
      p.options.forEach((optName, optIdx) => {
        const values = this._optionValues(p, optIdx);
        const hidden = values.length <= 1 ? ' style="display:none"' : '';
        html += '<div class="kit-builder__option" data-option-index="' + (optIdx + 1) + '"' + hidden + '>' +
          '<div class="kit-builder__option-name">' +
          '<span>' + this._esc(optName) + ':</span> ' +
          '<span class="kit-builder__option-selected">' + this._esc(values[0] || '') + '</span>' +
          '</div><div class="kit-builder__option-values">';
        values.forEach((val, i) => {
          const id = 'kit-' + this.sectionId + '-mopt' + (optIdx + 1) + '-' + i;
          html +=
            '<input type="radio" class="kit-builder__radio" id="' + id + '" ' +
            'name="kit-' + this.sectionId + '-mopt' + (optIdx + 1) + '" ' +
            'value="' + this._esc(val) + '" data-option-index="' + (optIdx + 1) + '"' +
            (i === 0 ? ' checked' : '') + '>' +
            '<label for="' + id + '" class="kit-builder__label kit-builder__label--tag">' +
            this._esc(val) + '</label>';
        });
        html += '</div></div>';
      });
      return html;
    }

    /* ── Peca obrigatoria do passo pago atual (ou null) ── */
    _activeFixedProduct() {
      if (!this.giftMode || this.currentStep > this.giftPaid) return null;
      return this.fixedProducts[this.currentStep - 1] || null;
    }

    /* ── Ajusta produto/opcoes conforme o passo (obrigatorio x livre) ── */
    _applyStepProduct() {
      const fixed = this._activeFixedProduct();

      if (fixed) {
        const mode = 'fixed-' + (this.currentStep - 1);
        if (this._renderMode === mode) return;
        this._renderMode = mode;
        this.variants = fixed.variants;
        this.options  = fixed.options;
        this._syncProductHeader(fixed);
        this.variantsEl.innerHTML = this._renderOptionRowsHTML(fixed);
        return;
      }

      if (this._renderMode === 'pool') return;
      this._renderMode = 'pool';
      if (this.multi) {
        const p = this.products[this.currentProductIdx];
        this.variants = p.variants;
        this.options  = p.options;
        this._syncProductHeader();
        this._renderMultiVariants();
        this._buildSwatchStyles();
      } else {
        this.variants = this.data.variants;
        this.options  = this.data.options;
        this._syncProductHeader({
          title:    this.data.title,
          image:    this.data.featured_image,
          variants: this.data.variants
        });
        this.variantsEl.innerHTML = this._staticVariantsHTML;
      }
    }

    _bindProductSwatches() {
      /* Delegado no container: sobrevive aos re-renders das opcoes */
      this.el.addEventListener('change', (e) => {
        const input = e.target;
        if (!input.classList.contains('kit-builder__radio--product')) return;
        this._setActiveProduct(parseInt(input.value, 10));
      });
    }

    _setActiveProduct(idx) {
      if (idx === this.currentProductIdx || !this.products[idx]) return;
      this.currentProductIdx = idx;
      const p = this.products[idx];
      this.variants = p.variants;
      this.options  = p.options;

      this._syncProductHeader();
      this._renderMultiVariants();
      this._buildSwatchStyles();
      this._selectFirstAvailable();
      this._hideAlert();
    }

    /* Thumb + titulo + preco comparado acompanham o produto ativo
       (ou o produto passado — usado nos passos de peca obrigatoria) */
    _syncProductHeader(prod) {
      const p = prod || this.products[this.currentProductIdx];
      if (!p) return;
      if (this.thumb)     { this.thumb.src = p.image; this.thumb.alt = p.title; }
      if (this.itemTitle) this.itemTitle.textContent = p.title;
      if (this.priceCompare) {
        const v = p.variants.find(v => v.available) || p.variants[0];
        const cmp = v && v.compare_at_price ? v.compare_at_price / 100 : null;
        this.priceCompare.textContent = cmp ? this._formatPrice(cmp) : '';
      }
    }

    /* ── Swatches: usa o mesmo mapa de cores do tema (window.themeSettings.productColors) ──
       Re-executavel: no modo multi-produto roda de novo a cada troca de produto. */
    _buildSwatchStyles() {
      if (this._swatchStyleEl) { this._swatchStyleEl.remove(); this._swatchStyleEl = null; }
      const labels = this.el.querySelectorAll('.kit-builder__label--swatch');
      if (!labels.length) return;

      // Pega o mapa de cores do tema (mesmo que customSwatchColors do theme.js)
      const colorMap = {};
      if (window.themeSettings && window.themeSettings.productColors) {
        window.themeSettings.productColors.split(',').forEach(entry => {
          const parts = entry.split(':');
          if (parts.length >= 2) {
            const name = parts[0].trim().toLowerCase();
            const color = parts.slice(1).join(':').trim();
            colorMap[name] = color;
          }
        });
      }

      // Injeta estilos via <style> para que ::before receba a cor corretamente
      const styleEl = document.createElement('style');
      let css = '';
      labels.forEach((label, i) => {
        const swatchName = (label.dataset.swatch || '').toLowerCase();
        const color = colorMap[swatchName];
        if (color) {
          // Adiciona um atributo único para targeting
          label.setAttribute('data-swatch-idx', i);
          css += `#kit-builder-${this.sectionId} [data-swatch-idx="${i}"]::before { background-color: ${color} !important; background-image: none !important; }\n`;
        } else {
          // Sem cor mapeada: usa cinza claro como fallback visível
          label.setAttribute('data-swatch-idx', i);
          css += `#kit-builder-${this.sectionId} [data-swatch-idx="${i}"]::before { background-color: #cccccc !important; }\n`;
        }
      });
      styleEl.textContent = css;
      document.head.appendChild(styleEl);
      this._swatchStyleEl = styleEl;
    }

    /* ── Formata preço para padrão brasileiro (99.90 → 99,90) ── */
    _formatPrice(val) {
      const num = parseFloat(String(val).replace(',', '.'));
      if (isNaN(num)) return val;
      return num.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }

    /* ── Barra de progresso ── */
    _buildProgressBar() {
      let bar = this.el.querySelector('.kit-builder__progress');
      if (!bar) {
        bar = document.createElement('div');
        bar.className = 'kit-builder__progress';
        this.boxEl.insertBefore(bar, this.boxEl.firstChild);
      }
      this.progressBar = bar;
      this._renderProgress();
    }

    _renderProgress() {
      const bar  = this.progressBar;
      bar.innerHTML = '';
      for (let i = 1; i <= this.currentKitSize; i++) {
        const dot = document.createElement('div');
        dot.className = 'kit-builder__progress-dot';
        if (i < this.currentStep)       dot.classList.add('kit-builder__progress-dot--done');
        else if (i === this.currentStep) dot.classList.add('kit-builder__progress-dot--active');
        if (this.giftMode && i > this.giftPaid) dot.classList.add('kit-builder__progress-dot--gift');
        bar.appendChild(dot);
      }
    }

    /* ── Tier buttons (1un / Kit 3 / Kit 5) ── */
    _bindTierBtns() {
      this.tierBtns.forEach(btn => {
        btn.addEventListener('click', () => {
          const url = btn.dataset.kitUrl;

          // Se tiver URL configurada, redireciona para a página do kit
          if (url && url.trim() !== '') {
            window.location.href = url.trim();
            return;
          }

          // Sem URL: comportamento padrão (passo a passo na mesma página)
          this.tierBtns.forEach(b => b.classList.remove('kit-builder__tier-btn--active'));
          btn.classList.add('kit-builder__tier-btn--active');

          this.currentKitSize = parseInt(btn.dataset.kitSize, 10);

          /* Tier "compre e ganhe": passos alem de kitPaid sao brinde */
          this.giftMode = btn.dataset.kitGift === 'true';
          this.giftPaid = this.giftMode ? parseInt(btn.dataset.kitPaid, 10) : 0;

          this.currentStep = 1;
          this.selections  = [];

          this._applyStepProduct();
          this._renderProgress();
          this._selectFirstAvailable();
          this._updateUI();
        });
      });
    }

    /* ── Inputs de variante (radio) ── */
    _bindVariantInputs() {
      this.el.addEventListener('change', (e) => {
        const input = e.target;
        if (!input.classList.contains('kit-builder__radio')) return;
        if (input.classList.contains('kit-builder__radio--product')) return;
        const optIdx = parseInt(input.dataset.optionIndex, 10) - 1;
        const optName = this.el.querySelector(
          `.kit-builder__option[data-option-index="${optIdx + 1}"] .kit-builder__option-name .kit-builder__option-selected`
        );
        if (optName) optName.textContent = input.value;
        // Roda disponibilidade primeiro, depois garante seleção válida
        this._checkVariantAvailability();
        this._ensureValidSizeSelected();
      });
    }

    /* ── Garante que o tamanho selecionado é válido após troca de cor ── */
    _ensureValidSizeSelected() {
      this.options.forEach((_, optIdx) => {
        let checkedInput = this.el.querySelector(
          `.kit-builder__radio[data-option-index="${optIdx + 1}"]:checked`
        );
        if (!checkedInput) return;

        // Verifica se o tamanho atual ainda está visível
        const checkedLabel = this.el.querySelector(`label[for="${checkedInput.id}"]`);
        if (checkedLabel && checkedLabel.style.display === 'none') {
          // Seleciona o primeiro tamanho visível disponível
          const allInputs = this.el.querySelectorAll(`.kit-builder__radio[data-option-index="${optIdx + 1}"]`);
          for (const inp of allInputs) {
            const lbl = this.el.querySelector(`label[for="${inp.id}"]`);
            if (lbl && lbl.style.display !== 'none') {
              inp.checked = true;
              checkedInput = inp;
              break;
            }
          }
        }

        // Sincroniza o texto do cabeçalho com o input realmente marcado
        // (a troca automática em _checkVariantAvailability não atualiza o texto)
        const optName = this.el.querySelector(
          `.kit-builder__option[data-option-index="${optIdx + 1}"] .kit-builder__option-selected`
        );
        if (optName) optName.textContent = checkedInput.value;
      });
    }

    /* ── Checar disponibilidade com base na seleção atual ── */
    _checkVariantAvailability() {
      const selected = this._getSelectedOptions();

      this.el.querySelectorAll('.kit-builder__label').forEach(label => {
        const input = document.getElementById(label.htmlFor);
        if (!input) return;

        // Swatches de cor e miniaturas de produto: sempre visíveis
        if (label.classList.contains('kit-builder__label--swatch') ||
            label.classList.contains('kit-builder__label--product')) {
          label.classList.remove('kit-builder__label--unavailable');
          label.style.display = '';
          return;
        }

        // Tags de tamanho: oculta se não tiver estoque para a cor selecionada
        const optIdx  = parseInt(input.dataset.optionIndex, 10) - 1;
        const testVal = input.value;
        const combo   = selected.map((sel, i) => i === optIdx ? testVal : sel);

        const hasAvailable = this.variants.some(v =>
          combo.every((opt, i) => opt === null || v.options[i] === opt) && v.available
        );

        if (!hasAvailable) {
          // Se estava selecionado, troca para o primeiro disponível
          if (input.checked) {
            const firstAvailableInput = this.el.querySelector(
              `.kit-builder__radio[data-option-index="${optIdx + 1}"]`
            );
            if (firstAvailableInput) {
              // Procura próximo disponível visível
              const allInputs = this.el.querySelectorAll(`.kit-builder__radio[data-option-index="${optIdx + 1}"]`);
              for (const inp of allInputs) {
                const c = selected.map((sel, i) => i === optIdx ? inp.value : sel);
                const ok = this.variants.some(v =>
                  c.every((opt, i) => opt === null || v.options[i] === opt) && v.available
                );
                if (ok) { inp.checked = true; break; }
              }
            }
          }
          label.style.display = 'none';
        } else {
          label.style.display = '';
          label.classList.remove('kit-builder__label--unavailable');
        }
      });
    }

    /* ── Retorna opções selecionadas no passo atual ── */
    _getSelectedOptions() {
      const selected = [];
      this.options.forEach((_, idx) => {
        const checked = this.el.querySelector(
          `.kit-builder__radio[data-option-index="${idx + 1}"]:checked`
        );
        selected.push(checked ? checked.value : null);
      });
      return selected;
    }

    /* ── Encontra variante pelo array de opções ── */
    _findVariant(optionsArray) {
      // Filtra nulls
      const opts = optionsArray.filter(o => o !== null);
      return this.variants.find(v =>
        opts.every((opt, i) => v.options[i] === opt)
      );
    }

    /* ── Avança para próximo passo ── */
    _bindNext() {
      this.btnNext.addEventListener('click', () => {
        const selectedOpts = this._getSelectedOptions();
        const variant      = this._findVariant(selectedOpts);

        if (!variant) {
          this._showAlert('Por favor, selecione todas as opções.');
          return;
        }

        /* Salva seleção do passo atual */
        const fixed = this._activeFixedProduct();
        const activeProduct = fixed || (this.multi ? this.products[this.currentProductIdx] : null);
        this.selections[this.currentStep - 1] = {
          variantId:  variant.id,
          options:    selectedOpts,
          productIdx: (fixed || !this.multi) ? null : this.currentProductIdx,
          title:      activeProduct ? activeProduct.title : this.data.title,
          image:      activeProduct ? activeProduct.image : this.data.featured_image
        };

        if (this.currentStep < this.currentKitSize) {
          this.currentStep++;
          this._applyStepProduct();
          this._resetInputsForStep();
          this._updateUI();
        } else {
          /* Último passo: adicionar tudo ao carrinho */
          this._addKitToCart();
        }
      });
    }

    /* ── Volta ao passo anterior ── */
    _bindBack() {
      this.btnBack.addEventListener('click', () => {
        if (this.currentStep > 1) {
          this.currentStep--;
          this._applyStepProduct();
          this._restoreSelectionForStep(this.currentStep - 1);
          this._updateUI();
        }
      });
    }

    /* ── Reseta radios para novo passo (mantém primeiro de cada opção) ── */
    /* ── Seleciona a primeira variante disponível em estoque ── */
    _selectFirstAvailable() {
      // Pega a primeira opção de cada grupo (primeira cor, depois primeiro tamanho disponível para ela)
      this.options.forEach((_, optIdx) => {
        const allInputs = this.el.querySelectorAll(
          `.kit-builder__radio[data-option-index="${optIdx + 1}"]`
        );
        if (!allInputs.length) return;

        if (optIdx === 0) {
          // Primeira opção (cor): sempre seleciona a primeira da lista
          const firstInput = allInputs[0];
          firstInput.checked = true;
          const optName = this.el.querySelector(
            `.kit-builder__option[data-option-index="1"] .kit-builder__option-selected`
          );
          if (optName) optName.textContent = firstInput.value;
        }
      });

      // Após definir a cor, roda disponibilidade e seleciona primeiro tamanho válido
      this._checkVariantAvailability();
      this._ensureValidSizeSelected();
    }

    _resetInputsForStep() {
      this._selectFirstAvailable();
    }

    /* ── Restaura seleção de um passo já salvo ── */
    _restoreSelectionForStep(stepIdx) {
      const saved = this.selections[stepIdx];
      if (!saved) return;

      /* Multi: volta primeiro para o produto daquele passo
         (passos de peca obrigatoria nao tem troca de produto) */
      if (!this._activeFixedProduct() && this.multi && saved.productIdx !== null && saved.productIdx !== this.currentProductIdx) {
        const radio = this.el.querySelector(
          `.kit-builder__radio--product[value="${saved.productIdx}"]`
        );
        if (radio) radio.checked = true;
        this._setActiveProduct(saved.productIdx);
      }

      saved.options.forEach((val, idx) => {
        const input = this.el.querySelector(
          `.kit-builder__radio[data-option-index="${idx + 1}"][value="${CSS.escape(val)}"]`
        );
        if (input) {
          input.checked = true;
          const optName = this.el.querySelector(
            `.kit-builder__option[data-option-index="${idx + 1}"] .kit-builder__option-selected`
          );
          if (optName) optName.textContent = val;
        }
      });
      this._checkVariantAvailability();
    }

    /* ── Atualiza UI de acordo com o passo atual ── */
    _updateUI() {
      const isKit      = this.currentKitSize > 1;
      const isLast     = this.currentStep === this.currentKitSize;
      const isGiftStep = this.giftMode && this.currentStep > this.giftPaid;

      /* Cabeçalho de passo — esconde quando é 1 unidade ou tudo oculto no bloco */
      const header = this.el.querySelector('.kit-builder__header');
      if (header) header.style.display = (isKit && (this.badgeShow || this.textShow)) ? 'block' : 'none';

      /* Barra de progresso — esconde quando é 1 unidade */
      if (this.progressBar) this.progressBar.style.display = isKit ? 'flex' : 'none';

      /* Selo do passo: template configuravel ({passo}/{total}) + verde no brinde */
      if (this.stepBadge) {
        this.stepBadge.textContent = this.badgeTemplate
          .replace('{passo}', this.currentStep)
          .replace('{total}', this.currentKitSize);
        this.stepBadge.classList.toggle('kit-builder__step-badge--gift', isGiftStep);
      }

      /* Texto ao lado do selo: configuravel por tipo de passo */
      if (this.stepText) {
        this.stepText.textContent = isGiftStep
          ? this.stepTexts.gift
          : (this._activeFixedProduct() ? this.stepTexts.fixed : this.stepTexts.normal);
      }

      /* Botão next */
      if (this.btnText) {
        this.btnText.textContent = (!isKit || isLast)
          ? 'Adicionar ao carrinho'
          : `Ir para o próximo item →`;
      }

      /* Botão voltar */
      if (this.backWrap) {
        this.backWrap.style.display = (isKit && this.currentStep > 1) ? 'block' : 'none';
      }

      /* Preço por unidade conforme tier ativo (GRÁTIS no passo de brinde) */
      const activeBtn = this.el.querySelector('.kit-builder__tier-btn--active');
      if (this.priceCurrent) {
        if (isGiftStep) {
          this.priceCurrent.classList.add('kit-builder__price-current--gratis');
          this.priceCurrent.textContent = 'GRÁTIS';
          this.priceValue = null;
        } else {
          this.priceCurrent.classList.remove('kit-builder__price-current--gratis');
          let price = (activeBtn && activeBtn.dataset.kitPrice) || this.kitPrices[0] || '';
          if (!price || isNaN(parseFloat(String(price).replace(',', '.')))) {
            /* Sem preco configurado no bloco: usa o preco real da variante */
            const v = this.variants.find(v => v.available) || this.variants[0];
            if (v) price = String(v.price / 100);
          }
          this.priceCurrent.innerHTML = 'R$ <span class="kit-builder__price-value">' + this._formatPrice(price) + '</span>';
          this.priceValue = this.priceCurrent.querySelector('.kit-builder__price-value');
        }
      }
      if (this.priceSubtitle) {
        this.priceSubtitle.textContent = isGiftStep ? 'Brinde do kit:' : '1 unidade no kit por:';
      }
      if (this.priceCompare) this.priceCompare.style.display = isGiftStep ? 'none' : '';

      /* Limpa alerta */
      this._hideAlert();
      this._checkVariantAvailability();
    }

    /* ── Adiciona todos os itens do kit ao carrinho via AJAX ── */
    async _addKitToCart() {
      /* Guard de reentrada: duplo clique nao pode enviar o kit 2x */
      if (this._adding) return;
      this._adding = true;
      this.btnNext.classList.add('with-loader--show');

      const items = this.selections.map((sel, i) => {
        const item = { id: sel.variantId, quantity: 1 };
        /* Passos alem das pecas pagas sao brinde: marca no pedido
           (o desconto automatico "Compre X e ganhe Y" zera o valor no checkout) */
        if (this.giftMode && i >= this.giftPaid) {
          item.properties = { '_brinde': 'Brinde do kit' };
        }
        return item;
      });

      try {
        const res = await fetch('/cart/add.js', {
          method:  'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body:    JSON.stringify({ items })
        });

        const data = await res.json();

        if (!res.ok) {
          const msg = data && data.description ? data.description : 'Não foi possível adicionar ao carrinho. Tente novamente.';
          throw new Error(msg);
        }

        /* Atualiza contador do carrinho */
        const cartRes = await fetch('/cart.js');
        const cartData = await cartRes.json();
        if (window.theme && window.theme.cart) {
          window.theme.cart.updateTotalItems(cartData.item_count);
        }

        /* Abre o drawer APENAS no último passo (kit completo adicionado) */
        if (window.theme && window.theme.cart && window.theme.cart.drawer) {
          window.theme.cart.drawer.openDrawer();
        } else {
          const drawerTrigger = document.querySelector('.js-cart-drawer-toggle');
          if (drawerTrigger) drawerTrigger.click();
        }

        /* Reset */
        this.currentStep = 1;
        this.selections  = [];
        this._resetInputsForStep();
        this._updateUI();

      } catch (err) {
        this._showAlert('Ops! ' + err.message);
        console.error('[KitBuilder]', err);
      } finally {
        this._adding = false;
        this.btnNext.classList.remove('with-loader--show');
      }
    }

    _showAlert(msg) {
      let alert = this.el.querySelector('.kit-builder__alert');
      if (!alert) {
        alert = document.createElement('div');
        alert.className = 'kit-builder__alert';
        this.boxEl.insertBefore(alert, this.btnNext);
      }
      alert.textContent = msg;
      alert.style.display = 'block';
    }

    _hideAlert() {
      const alert = this.el.querySelector('.kit-builder__alert');
      if (alert) alert.style.display = 'none';
    }
  }

  /* ── Init ── */
  function initKitBuilders() {
    document.querySelectorAll('.kit-builder').forEach(el => {
      if (!el._kitBuilderInitialized) {
        el._kitBuilderInitialized = true;
        new KitBuilder(el);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initKitBuilders);
  } else {
    initKitBuilders();
  }

  /* Reinit após navegação SPA (se o tema usar) */
  document.addEventListener('shopify:section:load', initKitBuilders);

})();
